/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui";
import {
  useSaveCall,
  useGetTicketDetails,
  useSubmitTicket,
  useCreateCall,
  useAddSite,
} from "services/tickets";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import {
  useLookupCustomers,
  useLookupGetContracts,
  useLookupGetSecurityTypes,
  useLookupGetSites,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { emptyTicket, PRIORITIES_LIST } from "../constants";
import FormSelect from "ui/select";

const emptyRequest = {
  ...emptyTicket,
  activityType: "Voice of Staff",
  assignmentGroup: "Cash Admin",
};

export default function CreateTGSIHelpDeskTicket() {
  const [ticketDetails, setTicketDetails] = useState({ ...emptyRequest });
  const [showAddSiteModal, setShowAddSiteModal] = useState(false);

  const params = useParams();
  const navigate = useNavigate();

  // API hooks
  const {
    mutate: getSecurityTypes,
    data: securityTypesRes,
    isPending: gettingSecurityTypes,
  } = useLookupGetSecurityTypes();
  const {
    mutate: getContracts,
    data: contractsRes,
    isPending: gettingContracts,
  } = useLookupGetContracts();
  const {
    mutate: getSites,
    data: sitesRes,
    isPending: gettingSites,
  } = useLookupGetSites();
  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
  } = useCreateCall();
  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
  } = useSaveCall();
  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
  } = useSubmitTicket();
  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();
  const { mutate: getCustomersList, data: customersListRes } =
    useLookupCustomers();
  const { mutate: createSite, isPending: creatingSite } = useAddSite();

  const form = useForm({ defaultValues: { ...emptyRequest } });
  const addSiteForm = useForm({
    defaultValues: { contractId: "", location: "", site: "", siteCode: "" },
  });

  useEffect(() => {
    getSecurityTypes();
    getCustomersList();
    getContracts();
    if (params.ticketId) getTicket(params.ticketId);
  }, []);

  useEffect(() => {
    if (ticketDetailsRes && contractsRes) {
      if (ticketDetailsRes.status === 200) {
        const _details = { ...ticketDetailsRes.data };
        form.reset({ ...emptyRequest, region: _details.state, ..._details });

        if (_details.tgsiSiteId) {
          const currentContract = contractsRes?.data.find(
            (elm) => elm.name === _details.category
          );
          if (currentContract) {
            getSites(currentContract.id);
          } else {
            form.setValue("tgsiSiteId", _details.tgsiSiteName);
          }
        }
        setTicketDetails({ ..._details });
        resetDetailsApi();
      }
    }

    if (createTicketRes || saveTicketRes || submitTicketRes) {
      navigate(PATHS.allServiceAndNonServiceCalls);
    }
  }, [
    createTicketRes,
    saveTicketRes,
    ticketDetailsRes,
    submitTicketRes,
    contractsRes,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };

  const verificationRules = {
    reportedBy: { required: "Please Enter Value" },
    requesterEmail: { required: "Please Enter Value" },
    requesterContactNo: { required: "Please Enter Value" },
    sites: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
  };

  const createTicketPayload = () => {
    const _data = form.getValues();
    const customer = customersListRes?.data.find(
      (elm) => elm.name === "Transguard Group (TG)"
    );
    return {
      customerId: customer?.customerId || "",
      activityType: "TGSI Helpdesk",
      category: _data.category,
      subCategory: _data.subCategory,
      assignmentGroup: "TGSI Maintenance group",
      creationChannel: "Web",
      reportedBy: _data.reportedBy,
      isChargeable: false,
      isCustomerComplaint: false,
      billingCharges: false,
      correlationId: "",
      priority: _data.priority
        ? PRIORITIES_LIST.filter((elm) => elm.id === _data.priority)[0].value
        : "",
      remarks: _data.remarks,
      requesterContactNo: _data.requesterContactNo,
      requesterEmail: _data.requesterEmail,
      tgsiSiteId: _data.tgsiSiteId,
      tgsiSiteName: _data.tgsiSiteName,
    };
  };

  const onSubmit = () => {
    const _data = form.getValues();
    const payload = { ticketId: _data.ticketId, ...createTicketPayload() };
    submitTicket({ ...payload });
  };

  const onSave = () => createTicket(createTicketPayload());
  const onSaveAsDraft = () => saveTicket(createTicketPayload());
  const onReset = () => form.reset({ ...ticketDetails });
  const addSite = () => {
    form.reset({ ...ticketDetails });
    setShowAddSiteModal(true);
  };

  const onContractChange = (data) => {
    const currentContract = contractsRes?.data.find((elm) => elm.name === data);
    if (currentContract) getSites(currentContract.id);
    form.setValue("tgsiSiteId", "");
  };
  const onSiteChange = (data) => {
    const currentSite = sitesRes?.data.find((elm) => elm.id === data);
    if (currentSite) form.setValue("tgsiSiteName", currentSite.siteName);
  };

  const handleAddSiteSubmit = () => {
    const contractValue = addSiteForm.getValues("contractId");
    const selectedContract = contractsRes?.data?.find(
      (elm) => elm.id === contractValue || elm.name === contractValue
    );
    form.reset({ ...ticketDetails });

    const payload = {
      contractId: selectedContract?.id || contractValue || "",
      location: addSiteForm.getValues("location"),
      site: addSiteForm.getValues("site"),
      siteCode: addSiteForm.getValues("siteCode"),
    };
    if (!payload.contractId) return;
    createSite(payload, {
      onSuccess: () => {
        addSiteForm.reset();
        setShowAddSiteModal(false);
        // getSites(payload.contractId);
      },
    });
  };

  return (
    <>
      {savingTicket ||
      creatingTicket ||
      gettingTicket ||
      submittingTicket ||
      gettingSecurityTypes ||
      gettingContracts ||
      gettingSites ||
      creatingSite ? (
        <Loader />
      ) : null}

      <div className="form-container">
        <Breadcrumb className="mt-5 text-black">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink>
                <Link to={PATHS.openTickets} className="text-black">
                  Tickets
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-black" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-black">
                Create Ticket
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="flex flex-row justify-end w-full gap-2 mt-3">
          <Button variant="secondary" onClick={addSite}>
            Add Site
          </Button>

          {form.watch("status") !== "Draft" ? (
            <Button variant="secondary" onClick={form.handleSubmit(onSave)}>
              Save
            </Button>
          ) : (
            <Button variant="secondary" onClick={form.handleSubmit(onSubmit)}>
              Submit
            </Button>
          )}

          <Button
            variant="secondary"
            onClick={form.handleSubmit(onSaveAsDraft)}
          >
            Save As Draft
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>
          <Link to={PATHS.openTickets}>
            <Button variant="secondary">Cancel</Button>
          </Link>
        </div>

        <Card className="form-card shadow-lg mx-0 mt-4">
          <CardHeader>
            <CardTitle>TGSI Help Desk</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="reportedBy"
                    label="Requestor Name"
                    rules={verificationRules.reportedBy}
                  />
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="priority"
                    label="Priority"
                    placeholder="Select Priority"
                    data={PRIORITIES_LIST}
                    id="id"
                    text="text"
                    rules={verificationRules.priority}
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="requesterContactNo"
                    label="Requestor Contact"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Security Type"
                    name="subCategory"
                    isRequired
                    placeholder="Select Security Type"
                    rules={verificationRules.securityType}
                    data={securityTypesRes?.data || []}
                    text="name"
                    id="name"
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="requesterEmail"
                    label="Requestor Email"
                    rules={verificationRules.requesterEmail}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Contracts"
                    name="category"
                    isRequired
                    placeholder="Select Contract"
                    rules={verificationRules.category}
                    data={contractsRes?.data || []}
                    text="name"
                    id="name"
                    onChange={onContractChange}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Sites"
                    name="tgsiSiteId"
                    isRequired
                    placeholder="Select Sites"
                    rules={verificationRules.sites}
                    data={sitesRes?.data || []}
                    text="displayText"
                    id="id"
                    onChange={onSiteChange}
                    info={
                      form.watch("category")
                        ? ""
                        : "Select Contracts To Load Data"
                    }
                  />
                </div>

                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />
                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? { borderColor: "red" }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors?.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>

      <Dialog open={showAddSiteModal} onOpenChange={setShowAddSiteModal}>
        <DialogContent
          onOpenAutoFocus={(e) => e.preventDefault()}
          className="sm:max-w-[500px]"
        >
          <DialogHeader>
            <DialogTitle>Add Site</DialogTitle>
          </DialogHeader>

          <Form {...addSiteForm}>
            <form
              onSubmit={addSiteForm.handleSubmit(handleAddSiteSubmit)}
              className="space-y-4 mt-2"
            >
              <FormDropdown
                errors={addSiteForm.formState.errors}
                control={addSiteForm.control}
                label="Contract"
                name="contractId"
                isRequired
                placeholder="Select Contract"
                data={contractsRes?.data || []}
                text="name"
                id="id"
                rules={{ required: "Please select a contract" }}
              />

              <FormInput
                errors={addSiteForm.formState.errors}
                control={addSiteForm.control}
                name="location"
                label="Location"
                isRequired
                rules={{ required: "Please enter a location" }}
              />

              <FormInput
                errors={addSiteForm.formState.errors}
                control={addSiteForm.control}
                name="siteCode"
                label="Site Code"
                isRequired
                rules={{ required: "Please enter a site code" }}
              />

              <FormInput
                errors={addSiteForm.formState.errors}
                control={addSiteForm.control}
                name="site"
                label="Site"
                isRequired
                rules={{ required: "Please enter a site name" }}
              />

              <div className="flex justify-end gap-2 mt-6">
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => setShowAddSiteModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="secondary"
                  disabled={creatingSite}
                >
                  {creatingSite ? "Adding..." : "Update"}
                </Button>
              </div>
            </form>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  );
}
